import { api_POST } from "services/api_service.js";

export const CancelarRequerimentoByRequerimento = (requerimento_Id, usuario_Id, callback) => {
    api_POST(`requerimento/PostCancelaRequerimento/${requerimento_Id}/` + usuario_Id).then(result => {
        callback(result);
    });
}

export const CancelarRequerimentoByProtocolo = (protocolo_Id, callback) => {
    api_POST(`requerimento/CancelaRequerimentoByProtocolo/${protocolo_Id}`).then(result => {
        callback(result);
    });
}